/**
 * @author Sarthak Sharma.
 * @since 02-02-2024.
 * @type {string} Media action types.
 */

export const SET_LOADING = '[ARTIST_MEDIA] SET_LOADING';

export const SET_RECRUITER_IMAGES = '[ARTIST_MEDIA] SET_RECRUITER_IMAGES';
export const APPEND_RECRUITER_IMAGES = '[ARTIST_MEDIA] APPEND_RECRUITER_IMAGES';
export const SET_RECRUITER_IMAGES_META = '[ARTIST_MEDIA] SET_RECRUITER_IMAGES_META';

export const SET_RECRUITER_VIDEOS = '[ARTIST_MEDIA] SET_RECRUITER_VIDEOS';
export const SET_RECRUITER_VIDEOS_META = '[ARTIST_MEDIA] SET_RECRUITER_VIDEOS_META';
export const APPEND_RECRUITER_VIDEOS = '[ARTIST_MEDIA] APPEND_RECRUITER_VIDEOS';

export const SET_ARTIST_IMAGES = '[ARTIST_MEDIA] SET_ARTIST_IMAGES';
export const SET_ARTIST_IMAGES_META = '[ARTIST_MEDIA] SET_ARTIST_IMAGES_META';
export const APPEND_ARTIST_IMAGES = '[ARTIST_MEDIA] APPEND_ARTIST_IMAGES';

export const SET_ARTIST_VIDEOS = '[ARTIST_MEDIA] SET_ARTIST_VIDEOS';
export const SET_ARTIST_VIDEOS_META = '[ARTIST_MEDIA] SET_ARTIST_VIDEOS_META';
export const APPEND_ARTIST_VIDEOS = '[ARTIST_MEDIA] APPEND_ARTIST_VIDEOS';

export const SET_ARTIST_AUDIOS = '[ARTIST_MEDIA] SET_ARTIST_AUDIOS';
export const SET_ARTIST_AUDIOS_META = '[ARTIST_MEDIA] SET_ARTIST_AUDIOS_META';
export const APPEND_ARTIST_AUDIOS = '[ARTIST_MEDIA] APPEND_ARTIST_AUDIOS';

export const SET_MEDIA_TAGS = '[ARTIST_MEDIA] SET_MEDIA_TAGS';
